import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ClientService} from '../../../Services/client.service';
import {AuthService} from '../../../auth/AuthService';
import {first} from 'rxjs/operators';
import swal from "sweetalert2";
import {ActivatedRoute, Router} from '@angular/router';
import {iClient} from '../../../Model/ClientModel';
import {statesDropdown} from '../../../shared/StatesUS';
import { formatDate } from '@angular/common';

@Component({
    selector: 'pm-add-update-client',
    templateUrl: './add-update-client.component.html',
    styleUrls: ['./add-update-client.component.css']
})
export class AddUpdateClientComponent implements OnInit {
    cRegisterForm!: FormGroup;
    clientId :any;
    status:boolean = false;
    phoneType: any = [
        {value: 'Mobile', viewValue: 'Mobile'},
        {value: 'Work', viewValue: 'Work'},
        {value: 'Home', viewValue: 'Home'},
    ];
    stateList:any = statesDropdown
    constructor(private fb: FormBuilder,
                private clientServices: ClientService,
                private authService: AuthService,
                private activatedRoute: ActivatedRoute,
                private route: Router) {

        this.clientId = this.activatedRoute.snapshot.paramMap.get('id');

        this.cRegisterForm = this.fb.group({
            id:[],
            name: [null, Validators.required],
            email: [null, [Validators.required, Validators.email]],
            number: [null, [Validators.required, Validators.pattern(/^\d{10}$|^\d{3}-\d{3}-\d{4}$/)]],
            phoneType: [null, Validators.required],
            firstLine: [null, Validators.required],
            city: [null, Validators.required],
            state: [null, Validators.required],
            zip: [null, Validators.required],
            softwareAndSystem: [null, Validators.required],
            authorizedSignatory: [null],
            designation: [null],
            integrationRequirements: [null],
            deactivationDate:[null],
            additionalInformation: [null],
        });

        if(this.clientId){
            let reqData:any ={
                clientId : this.clientId
            }
            this.clientServices.getClientDetails(reqData).pipe(first()).subscribe(
                (response: any) => {
                    if (response != undefined) {
                        let data = response[0];
                        this.status = data.active ? data.active : false;
                        this.cRegisterForm.patchValue({
                            id:data.id,
                            name: data.name ? data.name: null,
                            email: data.contact.email ? data.contact.email : null,
                            number: data.contact.phones[0].number ? data.contact.phones[0].number : null,
                            phoneType: data.contact.phones[0].phoneType ? data.contact.phones[0].phoneType : null,
                            firstLine: data.address.firstLine ? data.address.firstLine : null,
                            city: data.address.city ? data.address.city : null,
                            state: data.address.state ? data.address.state : null,
                            zip: data.address.zip ? data.address.zip : null,
                            softwareAndSystem: data.softwareAndSystem.length ? data.softwareAndSystem[0].name : null,
                            authorizedSignatory: data.authorizedSignatory ? data.authorizedSignatory : null,
                            designation: data.designation?.name ? data.designation.name : null,
                            integrationRequirements: data.integrationRequirements ? data.integrationRequirements : null,
                            deactivationDate: this.parseDeactivationDate(data.deactivationDate),
                            additionalInformation: data.additionalInformation ? data.additionalInformation : null,
                        });
                    } else {
                        swal.fire({
                            title: 'Error!',
                            icon: 'error',
                            text: response.message,
                            showConfirmButton: false,
                            timer: 5000
                        });
                    }
                },
                (error) => {
                    swal.fire({
                        title: 'Error!',
                        icon: 'error',
                        text: error.error.message,
                        showConfirmButton: false,
                        timer: 5000
                    });
                }
            );
        }
    }

    ngOnInit(): void {
    }
    private parseDeactivationDate(dateValue: string | null): Date | null {
    if (!dateValue) {
        return null;
    }

    const parts = dateValue.split('-');

    if (parts.length !== 3) {
        return null;
    }

    const month = Number(parts[0]);
    const day = Number(parts[1]);
    const year = Number(parts[2]);

    return new Date(year, month - 1, day);
    }
    // Change status
    changeStatus(status:any){
        if(status == true){
            this.status = false;
        }else{
            this.status = true;
        }
    }
    private removeEmptyFields(value: any): any {
    if (Array.isArray(value)) {
        const cleanedArray = value
            .map(item => this.removeEmptyFields(item))
            .filter(item =>
                item !== null &&
                item !== undefined &&
                item !== '' &&
                !(Array.isArray(item) && item.length === 0) &&
                !(this.isEmptyObject(item))
            );

        return cleanedArray.length > 0 ? cleanedArray : undefined;
    }

    if (value !== null && typeof value === 'object' && !(value instanceof Date)) {
        const cleanedObject: any = {};

        Object.keys(value).forEach(key => {
            const cleanedValue = this.removeEmptyFields(value[key]);

            if (
                cleanedValue !== null &&
                cleanedValue !== undefined &&
                cleanedValue !== '' &&
                !(Array.isArray(cleanedValue) && cleanedValue.length === 0) &&
                !this.isEmptyObject(cleanedValue)
            ) {
                cleanedObject[key] = cleanedValue;
            }
        });

        return Object.keys(cleanedObject).length > 0
            ? cleanedObject
            : undefined;
    }

    return value;
    }

    private isEmptyObject(value: any): boolean {
        return value !== null &&
            typeof value === 'object' &&
            !Array.isArray(value) &&
            Object.keys(value).length === 0;
    }
    // Register client function / update
    onRegister(): any {

    this.cRegisterForm.markAllAsTouched();

    if (this.cRegisterForm.invalid) {

        const invalidControls = Object.keys(this.cRegisterForm.controls)
            .filter(key => this.cRegisterForm.controls[key].invalid);

        // console.log('Invalid form controls:', invalidControls);

        invalidControls.forEach(key => {
            // console.log(
            //     'INVALID:',
            //     key,
            //     'VALUE:',
            //     this.cRegisterForm.controls[key].value,
            //     'ERRORS:',
            //     this.cRegisterForm.controls[key].errors
            // );
        });

        swal.fire({
            title: 'Validation Error',
            icon: 'warning',
            text: 'Please complete all required fields.',
            showConfirmButton: true
        });

        return;
    }

    const deactivationDateValue =
        this.cRegisterForm.controls.deactivationDate.value;

    const rawReqData: any = {
        name: this.cRegisterForm.controls.name.value,

        address: {
            firstLine: this.cRegisterForm.controls.firstLine.value,
            city: this.cRegisterForm.controls.city.value,
            state: this.cRegisterForm.controls.state.value,
            zip: this.cRegisterForm.controls.zip.value
        },

        contact: {
            phones: [
                {
                    number: this.cRegisterForm.controls.number.value,
                    phoneType: this.cRegisterForm.controls.phoneType.value
                }
            ],
            email: this.cRegisterForm.controls.email.value
        },

        softwareAndSystem: [
            {
                name: this.cRegisterForm.controls.softwareAndSystem.value
            }
        ],

        designation: {
            name: this.cRegisterForm.controls.designation.value
        },

        authorizedSignatory:
            this.cRegisterForm.controls.authorizedSignatory.value,

        integrationRequirements:
            this.cRegisterForm.controls.integrationRequirements.value,

        deactivationDate: deactivationDateValue
            ? formatDate(
                deactivationDateValue,
                'MM-dd-yyyy',
                'en-US'
            )
            : null,

        additionalInformation:
            this.cRegisterForm.controls.additionalInformation.value
    };

    const reqData: iClient = this.removeEmptyFields(rawReqData);

    if (this.clientId) {
        const params = {
            clientId: this.clientId,
            active: this.status
        };

        this.clientServices
            .updateClient(reqData, params)
            .pipe(first())
            .subscribe(
                (response: any) => {
                    if (response !== undefined) {
                        this.route.navigate(['client']);

                        swal.fire({
                            icon: 'success',
                            text:
                                'Client :- "' +
                                reqData.name +
                                '" updated successfully.',
                            showConfirmButton: false,
                            timer: 3000
                        });
                    } else {
                        swal.fire({
                            title: 'Error!',
                            icon: 'error',
                            text: response.message,
                            showConfirmButton: false,
                            timer: 5000
                        });
                    }
                },
                error => {
                    swal.fire({
                        title: 'Error!',
                        icon: 'error',
                        text: error.error.message,
                        showConfirmButton: false,
                        timer: 5000
                    });
                }
            );
    } else {
        this.clientServices
            .clientRegistration(reqData)
            .pipe(first())
            .subscribe(
                (response: any) => {
                    if (response !== undefined) {
                        this.route.navigate(['client']);

                        swal.fire({
                            icon: 'success',
                            text:
                                'Client :- "' +
                                reqData.name +
                                '" registered successfully.',
                            showConfirmButton: false,
                            timer: 3000
                        });
                    } else {
                        swal.fire({
                            title: 'Error!',
                            icon: 'error',
                            text: response.message,
                            showConfirmButton: false,
                            timer: 5000
                        });
                    }
                },
                error => {
                    swal.fire({
                        title: 'Error!',
                        icon: 'error',
                        text: error.error.message,
                        showConfirmButton: false,
                        timer: 5000
                    });
                }
            );
    }
    }

}
